import { render } from "./CoursesView.vue?vue&type=template&id=13f9c12e"
import script from "./CoursesView.vue?vue&type=script&lang=js"
export * from "./CoursesView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__